<template>
    <div class="row">
        <snappy-table
                :endpoint="'vessels/' + vesselId + '/contacts/' + contactId + '/audiences'"
                :columns="['status','name']"
                :headings="['Status','Group']"
                :templated-slot-names="['status', 'name']"
                table-class="subscribers-table"
                :filter-values="filterValues"
                :filterable-columns="['status', 'name']"
                record-type="Groups"
        >
            <template #status="{ row }">
                <div class="subscription-status">
                    <div @click="handleGroupMemberships(row)" v-if="row.status === 'member'" :class="'subscription-label subscribed label hoverable label-default label-'+ row.id" data-test="leave-group-button">
                        <div class="place-holder subscribed">
                            <i class="icon fas fa-check" aria-hidden="true"></i> MEMBER
                        </div>
                        <div class="action-wrapper unsubscribe-action">
                            <i class="icon fas fa-times" aria-hidden="true"></i> REMOVE
                        </div>
                    </div>
                    <div v-else @click="handleGroupMemberships(row)" :class="'subscription-label label label-default hoverable label-' + row.id" data-test="join-group-button">
                        <div class="place-holder subscribe-neutral"><i class="icon fas fa-plus" aria-hidden="true"></i></div>
                        <div class="action-wrapper subscribe-neutral">
                            <i class="icon fas fa-check" aria-hidden="true"></i> JOIN
                        </div>
                    </div>
                </div>
            </template>

            <template #name="{ row }">
                <span>
                    {{ row.name }} <span class="label label-id">ID: {{ row.id }}</span>
                </span>
            </template>
        </snappy-table>
    </div>
</template>

<script>
    import SnappyTable from '../../components/SnappyTable';
    import {joinGroup} from '../../utility/api/group/joinGroup';
    import {leaveGroup} from '../../utility/api/group/leaveGroup';

    export default {
        name: 'contact-edit-group-memberships-table',
        components: {SnappyTable},
        data() {
            return {
                filterValues: {
                    status : [
                        {'id': 'member', 'text': 'Member'},
                    ]
                }
            };
        },
        methods: {
            handleGroupMemberships(row) {
                let groupId = row.id;

                if( row.status === 'member' ) {
                    this.handleStatusClick(row, 'neutral');
                    leaveGroup(groupId, this.contactId);
                } else if (row.status === 'group' || row.status === 'neutral') {
                    this.handleStatusClick(row, 'member');
                    joinGroup(groupId, this.contactId);
                }
            },
            handleStatusClick(row, status) {
                row.status = status;

                setTimeout(() => {
                    let els = document.getElementsByClassName('label-' + row.id);

                    for(let i=0; i < els.length; i++) {

                        if( typeof els[i] !== 'undefined' ) {
                            els[i].classList.remove('hoverable');
                        }
                    }
                },50);

                setTimeout(() => {
                    let els = document.getElementsByClassName('label-' + row.id);

                    for(let i=0; i < els.length; i++) {
                        els[i].addEventListener("mouseout", function handler(e) {
                            if( typeof els[i] !== 'undefined' ) {
                                els[i].classList.add('hoverable');
                            }

                            e.currentTarget.removeEventListener(e.type, handler);
                        });
                    }
                },250);
            }
        },
        props: {
            vesselId: {
                type: Number,
                required: true
            },
            contactId: {
                type: Number,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .created_at > .VueTables__created_at-filter-wrapper {
        display:none;
    }
</style>